import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setAiContentWidgetShowAi = createAction(
  `${reduxKey}.SET_AICONTENT_WIDGET_SHOW_AI`,
  (showAi: boolean) => ({ showAi })
);

export const saveAiContent = createAction(
  `${reduxKey}.SAVE_AICONTENT`,
  () => ({})
);

export const saveAiContentSuccess = createAction(
  `${reduxKey}.SAVE_AICONTENT_SUCCESS`,
  () => ({})
);

export const saveAiContentFailure = createAction(
  `${reduxKey}.SAVE_AICONTENT_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
